import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { FC, useEffect, useState } from 'react';
import { navigationButtons } from '../navigationButtons';
import { Link } from 'react-router-dom';
import homeIcon from '../../../../../assets/img/mobileMenuIcons/home.svg';
import logo from '../../../../../assets/img/ufo.png';
import menuIcon from '../../../../../assets/img/list.svg';
import searchIcon from '../../../../../assets/img/search.svg'
import { Badge, Button } from '@mui/material';
import { AdminPanelSettingsRounded, ShoppingCart } from '@mui/icons-material';
import { useGlobalState } from '../../../../../context/context';
import styled, { keyframes } from 'styled-components';

const MobileNavigationContainer = styled.div`
    @media (min-width: 941px) {
        display: none;
    }
`;

const NavigationIcon = styled('img')(() => ({
    width: '45px',
    height: '45px',
    marginRight: '10px',
}));

const NavigationLink = styled(Link)`
    text-decoration: none;
    color: black;
`;

const SmallLogo = styled('img')(() => ({
    width: '70px',
    marginLeft: '10px',
}));

const LargeLogo = styled('img')(() => ({
    width: '100px',
    marginLeft: '10px',
}));

const FirstLane = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'white',
    height: '60px',
    boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.75)',
    zIndex: 1000,
    position: 'fixed',
    width: '100%',
    top: 0,

    '@media (max-height: 450px)': {
        display: 'none',
    },
}));

const MenuIcon = styled('img')(() => ({
    width: '30px',
    height: '30px',
    position: 'absolute',
    left: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
}));

const SearchIcon = styled('img')(() => ({
    width: '24px',
    height: '24px',
    position: 'absolute',
    right: '15px',
    top: '50%',
    transform: 'translateY(-50%)',
}));

const NavigationBar = styled('img')(() => ({
    display: 'none',
    width: '30px',
    height: '30px',
    position: 'fixed',
    left: '10px',
    top: 30,
    transform: 'translateY(-50%)',
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.1)',
    padding: '10px',
    borderRadius: '50%',

    '@media (max-height: 450px)': {
        display: 'block',
    },
}));

const MobileMenuItem = styled(ListItem)`
    background-color: #f1f1f1;
    border-radius: 10px;
    margin: 7px 10px 7px 10px;
    padding: 15px;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: #e1e1e1;
    }
`

const TopContainer = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '10px',
}));

const slideIn = keyframes`
  0% { opacity: 0; transform: translateY(10px) }
  100% { opacity: 1; transform: translateY(0) }
`;

const Rotator = styled('div')(() => ({
    textAlign: 'left',
    marginLeft: 8,
    minWidth: '18ch',        // nie łam “Mińsk Mazowiecki”
    whiteSpace: 'nowrap',
}));

const RotatorTitle = styled.div`
  font-weight: 800;
  letter-spacing: -0.01em;
  font-size: 16px;
  line-height: 1.15;
  background-image: linear-gradient(90deg, #2f3ea4 0%, #293a98 40%, #26358f 70%, #223083 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: ${slideIn} 0.35s ease;
  position: relative;
`;


interface MobileNavigationProps {
    onHandleClickSearchIcon?: () => void;
}

const MobileNavigation: FC<MobileNavigationProps> = ({
    onHandleClickSearchIcon,
}) => {
    const [showMenu, setShowMenu] = useState(false);
    const { state } = useGlobalState();
    const cartItems = state.basketFurniture;

    const rotatingNames = ['Warszawa', 'Mińsk Mazowiecki', 'Piaseczno'];
    const [rotIdx, setRotIdx] = useState(0);
    useEffect(() => {
        const id = setInterval(() => setRotIdx(v => (v + 1) % rotatingNames.length), 2000);
        return () => clearInterval(id);
    }, [rotatingNames.length]);

    return (
        <MobileNavigationContainer>
            <NavigationBar
                onClick={() => setShowMenu(true)}
                src={menuIcon}
                alt="menu"
            />
            <FirstLane>
                <MenuIcon onClick={() => setShowMenu(!showMenu)} src={menuIcon} alt="menu" />
                <Link to='/'>
                    <SmallLogo src={logo} alt='logo' />
                </Link>
                {onHandleClickSearchIcon && <SearchIcon onClick={onHandleClickSearchIcon} src={searchIcon} />}
            </FirstLane>
            <SwipeableDrawer
                anchor={'left'}
                open={showMenu}
                onClose={() => setShowMenu(false)}
                onOpen={() => setShowMenu(true)}
            >
                <Box
                    sx={{ width: 320, paddingRight: 2 }}
                    onClick={() => setShowMenu(false)}
                >
                    <TopContainer>
                        <LargeLogo src={logo} alt='logo' />
                        <Rotator>
                            <RotatorTitle key={rotIdx}>{rotatingNames[rotIdx]}</RotatorTitle>
                        </Rotator>
                    </TopContainer>
                    {state.isAuth && (
                        <Box sx={{ mx: 2, mt: 1, mb: 1 }}>
                            <Button
                                fullWidth
                                variant="outlined"
                                component={Link}
                                to="/adminPanel"
                                startIcon={<AdminPanelSettingsRounded />}
                                sx={{
                                    borderRadius: 2,
                                    py: 1.1,
                                    fontWeight: 800,
                                    textTransform: 'uppercase',
                                    color: 'black',
                                    letterSpacing: '.06em',
                                    boxShadow: '0 6px 14px rgba(34,48,131,0.25)',
                                    '&:hover': {
                                        filter: 'brightness(1.02)',
                                        boxShadow: '0 8px 16px rgba(34,48,131,0.35)',
                                    },
                                }}
                            >
                                Panel Admina
                            </Button>
                        </Box>
                    )}
                    <List>
                        <NavigationLink key='cart' to='/koszyk'>
                            <MobileMenuItem disablePadding>
                                <ListItemIcon sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Badge badgeContent={cartItems?.length || 0} color="secondary">
                                        <ShoppingCart fontSize='large' />
                                    </Badge>
                                </ListItemIcon>
                                <ListItemText primary={'Przejdź do wycen'} />
                            </MobileMenuItem>
                        </NavigationLink>
                        <NavigationLink key='home' to='/'>
                            <MobileMenuItem disablePadding>
                                <ListItemIcon>
                                    <NavigationIcon src={homeIcon} alt='menu' />
                                </ListItemIcon>
                                <ListItemText primary={'Strona główna'} />
                            </MobileMenuItem>
                        </NavigationLink>
                        {navigationButtons?.map((button) => (
                            <NavigationLink key={button.url} to={button.url}>
                                <MobileMenuItem disablePadding>
                                    <ListItemIcon>
                                        <NavigationIcon src={button.mobileIcon} alt={button.name} />
                                    </ListItemIcon>
                                    <ListItemText primary={button.name} />
                                </MobileMenuItem>
                            </NavigationLink>
                        ))}
                    </List>
                </Box>
            </SwipeableDrawer>
        </MobileNavigationContainer>
    );
};

export default MobileNavigation;